export const INIT_USER_INFO = 'INIT_USER_INFO';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';

export function initUserInfo(data) {
    return {type: INIT_USER_INFO, data};
}

export function updateUserInfo(data) {
    return {type: UPDATE_USER_INFO, data};
}